import { render, staticRenderFns } from "./Stage3.vue?vue&type=template&id=4daea2fc&scoped=true&"
import script from "./Stage3.vue?vue&type=script&lang=js&"
export * from "./Stage3.vue?vue&type=script&lang=js&"
import style0 from "./Stage3.vue?vue&type=style&index=0&id=4daea2fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daea2fc",
  null
  
)

export default component.exports